// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"showmorecatagory_buttonWrapper__3hjuM","contentText":"showmorecatagory_contentText__lcYiz"};